// src/components/ToastProvider.jsx
import React from 'react';
import { Toaster } from 'react-hot-toast';
import { TOAST_CONTAINER_STYLE, Z_INDEX } from '../../constants/zIndex.js';

// 🔧 Animation slide-down
export function ToastProvider() {
  return (
    <>
      <style>
        {`
          @keyframes qwen-slide-down {
            0% { transform: translateY(-100%); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          @keyframes qwen-fade-out {
            0% { opacity: 1; }
            100% { opacity: 0; }
          }
          [data-sonner-toaster] > [role='alert'] {
            animation: qwen-slide-down 0.3s cubic-bezier(0.33, 1, 0.68, 1);
            animation-fill-mode: both;
          }
          [data-rht-toaster] {
            z-index: 110000 !important;
            pointer-events: none;
          }
          [data-rht-toaster] > * {
            pointer-events: auto;
          }
          [data-sonner-toaster] > [data-removing='true'] {
            animation: qwen-fade-out 0.25s ease-in;
            animation-fill-mode: forwards;
          }
        `}
      </style>

      <Toaster
        position="top-center"
        reverseOrder={false}
        containerStyle={TOAST_CONTAINER_STYLE}
        toastOptions={{
          duration: 4000,
          style: {
            zIndex: Z_INDEX.TOAST,
            fontSize: '16px',
            padding: '14px 18px',
            fontWeight: 500,
            lineHeight: 1.45,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          },
          success: {
            style: {
              backgroundColor: 'rgba(230, 255, 240, 0.95)',
              color: '#065f46',
              border: '1px solid rgba(34, 197, 94, 0.15)',
              borderRadius: '12px',
              padding: '14px 18px',
              fontSize: '16px',
              fontWeight: 500,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            },
            iconTheme: {
              primary: '#059669',
              secondary: '#fff',
            },
          },
          error: {
            style: {
              backgroundColor: 'rgba(255, 240, 240, 0.95)',
              color: '#b91c1c',
              border: '1px solid rgba(239, 68, 68, 0.15)',
              borderRadius: '12px',
              padding: '14px 18px',
              fontSize: '16px',
              fontWeight: 500,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            },
            iconTheme: {
              primary: '#DC2626',
              secondary: '#fff',
            },
          },
          loading: {
            style: {
              backgroundColor: 'rgba(240, 248, 255, 0.95)',
              color: '#1e40af',
              border: '1px solid rgba(59, 130, 246, 0.15)',
              borderRadius: '12px',
              padding: '14px 18px',
              fontSize: '16px',
              fontWeight: 500,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            },
            iconTheme: {
              primary: '#3b82f6',
              secondary: '#fff',
            },
          },
        }}
      />
    </>
  );
}

